import React from 'react';

export default function CombinedStep({ state, setField }) {
    return (
        <div className="shipping-step">
            <h3>Combined Shipping</h3>
            <div className="shipping-card-grid two">
                <button
                    type="button"
                    className={`shipping-choice-card${state.allowCombinedShipping ? ' selected' : ''}`}
                    onClick={() => setField('allowCombinedShipping', true)}
                    aria-pressed={state.allowCombinedShipping === true}
                >
                    <strong>Allow combined shipping</strong>
                    <span>Charge less when a buyer orders multiple items from your store.</span>
                </button>
                <button
                    type="button"
                    className={`shipping-choice-card${!state.allowCombinedShipping ? ' selected' : ''}`}
                    onClick={() => setField('allowCombinedShipping', false)}
                    aria-pressed={state.allowCombinedShipping !== true}
                >
                    <strong>Do not combine</strong>
                    <span>Each item keeps its own shipping charge.</span>
                </button>
            </div>

            {state.allowCombinedShipping && (
                <div className="group">
                    <label>Secondary Item Rate</label>
                    <input
                        type="number"
                        value={state.secondaryRate ?? ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            const parsed = parseFloat(value);
                            setField('secondaryRate', value === '' || Number.isNaN(parsed) ? '' : parsed);
                        }}
                    />
                    <p className="help">
                        We use the highest rate as the primary charge; this rate applies to each additional item from your store.
                    </p>
                </div>
            )}
        </div>
    );
}
